export const viewType = {
  GRID: 'grid',
  LIST: 'list',
};
